import React, { Component } from "react";
import { Wrapper, Scroll } from "app/NativeComponents/common";
import { PillButton } from "app/NativeComponents/snippets";

import AddressItem from "./AddressItem";
import {
  checkIfUserHasBillingAddon,
  getBillingAddonId,
  renderPrice
} from "app/NativeActions";

import OnboardingText from "app/DealMachineCore/snippets/OnboardingText";

class Body extends Component {
  constructor(props) {
    super(props);

    this.handlePurchasePress = this.handlePurchasePress.bind(this);
    this.handleModalPress = this.handleModalPress.bind(this);
  }

  handleModalPress(addon) {
    this.props.updateBillingAddon({
      token: this.props.token,
      type: "purchase",
      slug: addon.slug,
      addon_id: addon.id
    });
  }
  handlePurchasePress() {
    const { card_info, billing_addons } = this.props;

    if (card_info.has_card) {
      const addon = billing_addons.find(item => item.slug === "mail_tracking");

      if (addon) {
        this.props.setModal({
          title: "Purchase add-on",
          description:
            "Are you sure you want to purchase this add-on? You will receive a pro-rated charge today. On your next billing cycle you will be charged " +
            renderPrice(addon.monthly_price) +
            ".",
          icon: "check",
          submit: "Confirm Purchase",
          onPress: () => this.handleModalPress(addon),
          cancel: "Not right now"
        });
        this.props.toggleModal({ show: true, type: "normal" });
      }
    } else {
      this.props.appRedirect({ redirect: "cardOnFile" });
    }
  }

  renderBillingAddonCopy() {
    const { billing_addons, mail_timeline, platform } = this.props;
    if (
      !checkIfUserHasBillingAddon({
        billing_addons: billing_addons,
        slug: "mail_tracking"
      }) &&
      mail_timeline.mail_provider !== "ballpoint" &&
      platform !== "ios"
    ) {
      return (
        <Wrapper style={{ padding: 20 }}>
          <OnboardingText
            slug="mailtrackingAddon"
            style={{
              padding: 0
            }}
            innerStyle={{
              padding: 20
            }}
          />
          <PillButton
            style={{ marginLeft: 0 }}
            primary={true}
            onPress={this.handlePurchasePress}
          >
            Purchase Add-on
          </PillButton>
        </Wrapper>
      );
    }
  }

  render() {
    return (
      <Wrapper>
        <Scroll>
          {this.props.mail_timeline.map((address, i) => {
            return <AddressItem address={address} key={i} {...this.props} />;
          })}
        </Scroll>
        {this.renderBillingAddonCopy()}
      </Wrapper>
    );
  }
}

export default Body;
